module.exports = __webpack_public_path__ + "media/Estou, sim.c32644cd.mp3";